module.exports = __webpack_public_path__ + "img/project_create_illo_welcome@2x.3231d6d7.png";